import config from "../config";

export const BuildUri = (
    path: string,
    replacementParams: any = {},
    queryParams: any = {},
): string => {
    let uri = config.BACKEND_URI + path;
    Object.keys(replacementParams).forEach(
        (key) =>
            (uri = uri.replace(
                new RegExp("{" + key + "}", "g"),
                replacementParams[key],
            )),
    );
    if (queryParams && Object.keys(queryParams).length > 0) {
        uri += "?1=1";
        Object.keys(queryParams)
            .filter((key) => queryParams[key] !== undefined)
            .forEach((key) => {
                const value = queryParams[key];
                if (Array.isArray(value)) {
                    if ((value as Array<any>).length === 0) {
                        return;
                    }
                    uri = `${uri}${(value as Array<any>)
                        .map(
                            (v) =>
                                `&${encodeURIComponent(
                                    key,
                                )}=${encodeURIComponent(v)}`,
                        )
                        .join("")}`;
                } else {
                    uri =
                        uri +
                        "&" +
                        encodeURIComponent(key) +
                        "=" +
                        encodeURIComponent(queryParams[key]);
                }
            });
    }
    return uri;
};

export const BuildPortalUri = (
    path: string,
    replacementParams: any = {},
    queryParams: any = {},
): string => {
    let uri = config.PORTAL_BACKEND_URI + path;
    Object.keys(replacementParams).forEach(
        (key) =>
            (uri = uri.replace(
                new RegExp("{" + key + "}", "g"),
                replacementParams[key],
            )),
    );
    if (queryParams && Object.keys(queryParams).length > 0) {
        uri += "?1=1";
        Object.keys(queryParams)
            .filter((key) => queryParams[key] !== undefined)
            .forEach((key) => {
                const value = queryParams[key];
                if (Array.isArray(value)) {
                    if ((value as Array<any>).length === 0) {
                        return;
                    }
                    uri = `${uri}${(value as Array<any>)
                        .map(
                            (v) =>
                                `&${encodeURIComponent(
                                    key,
                                )}=${encodeURIComponent(v)}`,
                        )
                        .join("")}`;
                } else {
                    uri =
                        uri +
                        "&" +
                        encodeURIComponent(key) +
                        "=" +
                        encodeURIComponent(queryParams[key]);
                }
            });
    }
    return uri;
};
